import {ViewStream} from 'spyne';
import {PageDeckSlideView} from 'components/pages/page-deck-slide-view';
import { SlideTraits} from 'traits/slide-traits';

export class PageDeckSlidePresentation extends ViewStream {

    constructor(props={}) {
        props.id = 'slide-presentation';
        props.traits = [SlideTraits]
        super(props);
    }

    addActionListeners() {
        // return nexted array(s)
        return [];
    }

    broadcastEvents() {
        // return nexted array(s)
        return [];
    }

    onRendered() {
      this.slide$AddSlides(this.props.data.slides);
    }

}

